import React from 'react';
import Modal from './Modal.jsx';

export default function MeetingSummaryViewModal({ open, onClose, summary, onEdit, onDelete }) {
  if (!summary) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={summary.held_on}
      footer={
        <>
          <button
            type="button"
            onClick={() => onDelete(summary)}
            style={{
              background: '#fff', color: '#9B1F26',
              fontSize: 12.5, fontWeight: 500,
              padding: '7px 14px', borderRadius: 6,
              border: '1px solid #E0DFD9', cursor: 'pointer',
              marginRight: 'auto'
            }}
          >Delete</button>
          <button
            type="button"
            onClick={() => onEdit(summary)}
            style={{
              background: '#1A1A1A', color: '#fff',
              fontSize: 12.5, fontWeight: 500,
              padding: '7px 14px', borderRadius: 6,
              border: 'none', cursor: 'pointer'
            }}
          >Edit</button>
        </>
      }
    >
      {summary.author?.name && (
        <div className="text-[11px] mb-3" style={{ color: '#9A9A95' }}>
          {summary.author.name}
        </div>
      )}
      <p
        className="text-[13px]"
        style={{ color: '#3A3A38', lineHeight: 1.55, whiteSpace: 'pre-wrap' }}
      >
        {summary.body}
      </p>
    </Modal>
  );
}
